import { ReactElement, useId } from 'react';
import MuiMenu, { MenuProps as MuiMenuProps } from '@mui/material/Menu';
import { MenuItemProps } from './MenuItem';
import { MenuList, MenuListProps } from './MenuList';

export type MenuItemType = MenuItemProps | ReactElement<{ id: string }>;

export interface MenuFooterLink {
  id: string;
  title: string;
  href: string;
}

export type MenuProps = MenuListProps &
  Omit<MuiMenuProps, 'anchorEl' | 'open' | 'onSelect' | 'onClose'> & {
    anchorEl: Element | null;
    open: boolean;

    onClose: () => void;
  };

export const Menu = ({ anchorEl, open, onClose, items, small, excludeListComponent, onSelect, ...props }: MenuProps) => {
  const id = useId();

  const menuListProps: MenuListProps = {
    items,
    small,
    excludeListComponent,
    onSelect,
  };

  return (
    <MuiMenu
      id={id}
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      MenuListProps={{
        disablePadding: true,
        'aria-labelledby': anchorEl?.id || undefined,
      }}
      {...props}
    >
      <MenuList {...menuListProps} />
    </MuiMenu>
  );
};
